const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgScotiabank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f41817;}.cls-2{fill:#fff;}")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 52,
    height: 52,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26,17.6a8.41,8.41,0,1,0,8.38,8.34A8.37,8.37,0,0,0,26,17.6ZM15.53,24.8c.08-.28.14-.44.17-.61a10.39,10.39,0,0,1,10.35-8.58c2.89,0,5.77,0,8.66,0a1.49,1.49,0,0,0,1.22-.54c1.55-1.76,3.13-3.49,4.7-5.23A5,5,0,0,0,41,9.33H24.79A10.45,10.45,0,0,0,14.27,20.64,9.68,9.68,0,0,0,15.53,24.8Zm20.86,2.37c-.07.24-.1.31-.12.39a10.42,10.42,0,0,1-10.53,8.85c-2.89,0-5.77,0-8.66,0a1.37,1.37,0,0,0-.91.38c-1.68,1.8-3.32,3.63-5,5.46a1.8,1.8,0,0,0-.21.36c.21,0,.34,0,.47,0H27A10.43,10.43,0,0,0,37.59,30.75,9.15,9.15,0,0,0,36.39,27.17Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScotiabank);
export default __webpack_public_path__ + "static/media/SCOTIABANK.3abcdd8ac1f8d9e8a6af71a717489139.svg";
export { ForwardRef as ReactComponent };